<template>
  <div>
    <div class="matting-tips" :style="handleStyle" v-show="isShow && !showMatting && hasMattingBtn">
        <div class="arrow"></div>
        <div class="text">
          <p>图片支持一键抠图啦</p>
          <p>当前限免使用，快来试试吧</p>
        </div>
      </div>
    <div class="handle-button" v-show="isShow" :style="handleStyle">
      <template v-for="info in button">
        <el-tooltip
          effect="dark"
          placement="top"
          :content="info.helpText"
          :open-delay="300"
          :key="info.action"
        >
          <div
            v-show="isShow"
            :class="{'op-handle-button': true, ['op-handle-' + info.action]: true, disabled: info.action === 'path-anim' && isPathAnimDisabled}"
            :data-id="sprite ? sprite.id : ''"
            @click.stop="actionHandle($event, info.action)"
            @mouseenter="onME($event)"
            @mouseleave="onML($event)"
            :style="{width: info.action === 'censoredInfo' ? '86px': ''}"
          >
            <div v-if="info.action === 'censoredInfo'" style="width: 86px; justify-content: center;">
              查看详情
            </div>
            <div v-if="info.action === 'next' && sprite">
              <div
                class="op-handle-size-minus"
                @click="actionHandle($event, 'size-minus')"
                @mousedown="sizeHoldDown($event, 'size-minus')"
                @mouseup="sizeHoldUp"
                @mouseleave="sizeHoldUp"
              >-</div>
              <input
                class="op-handle-size-text"
                type="text"
                v-model="fontSize"
                @focus="focusF()"
                v-on:blur="blurF()"
              />
              <div
                class="op-handle-size-plus"
                @click="actionHandle($event, 'size-plus')"
                @mousedown="sizeHoldDown($event, 'size-plus')"
                @mouseup="sizeHoldUp"
                @mouseleave="sizeHoldUp"
              >+</div>
            </div>
            <div v-if="info.action === 'stroke-width' && sprite">
              <div
                class="op-handle-size-minus"
                @click="actionHandle($event, 'stroke-width-minus')"
              >-</div>
              <input
                class="op-handle-size-text"
                type="text"
                placeholder="请输入"
                v-model="strokeWidth"
                @focus="focusF()"
                v-on:blur="blurF()"
              />
              <div class="op-handle-size-plus" @click="actionHandle($event, 'stroke-width-plus')">+</div>
            </div>
            <div
              v-else-if="info.action === 'color'"
              :style="Object.assign(opColorStyle, {boxShadow: `0 0 3px 0 rgba(0,0,0,0.5)`})"
            ></div>

            <i v-else :class="`icon icon-sprite-${getIconClass(info.action)}`"></i>
            <!-- <span v-if="info.action === 'swap' || info.action === 'favorite'">{{info.helpText}}</span> -->
          </div>
        </el-tooltip>
      </template>

      <div
        v-show="isShowRest"
        v-if="false"
        class="op-handle-button op-handle-delete"
        @click="delSprite()"
        @mousedown.stop
        @mouseenter="onME($event)"
        @mouseleave="onML($event)"
      >
        <i class="icon icon-sprite-delete"></i>
      </div>
    </div>
    <div
      v-show="sprite && sprite.action == 'spin'"
      class="rotate-show"
      :style="rotateStyle"
    >{{this.sprite? Math.ceil(this.sprite.rotate) +'°': 0+'°'}}</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import getNavType from "@/components/mixins/getNavType";
import analysis from "@/components/mixins/analysis/spriteBtns";
import textArtStyle from "@/components/mixins/textArtStyle";
import judgeMatting from '../mixins/judgeMatting';

export default {
  mixins: [getNavType, analysis, textArtStyle, judgeMatting],
  data() {
    return {
      // mattingFinished: false,
      isShow: false, // 是否显示帮助按钮
      isShowRest: false,
      sprite: null, // 当前元素
      type: "",
      position: {
        // 定位信息
        left: 0,
        top: 0
      },
      rotateShow: {
        // 旋转角度定位信息
        left: 0,
        top: 0
      },
      button: [], // 按钮的信息
      fontSize: 0, // 用于显示字体大小
      opColorStyle: {
        backgroundColor: "#5778fb"
      },
      strokeWidth: 0,
      swRange: {
        min: 1,
        max: 15
      },
      isPathAnimDisabled: false,
      holdTimer: null, //用于判断是否长按字体 “+”，“-”按钮
      sizeTimer: null, //执行长按字体加减
      holdStartTime: 0, //用于记录长按的起始时间
      holdEndTime: 0, //用于记录长按的结束时间
      favoriteStatus: 0, // 收藏状态 0 未收藏 1 在收藏 2 已收藏
      favoriteId: '' // 收藏的ID
    };
  },
  computed: {
    ...mapGetters([
      "TOOL",
      "Tool_Size",
      "SelectSprites_Msg",
      "MaterialPane_Size",
      "ToolScroll_Size",
      "TopNav_Size",
      "SelectScenes_Msg",
      "MaterialNavReady"
    ]),
    hasMattingBtn () {
      return this.button.find((item)=>
        item.action === 'matting'
      );
    },
    handleStyle() {
      const style = {};
      style.top = this.position.top + "px";
      style.left = this.position.left + "px";
      return style;
    },
    rotateStyle() {
      const style = {};
      style.top = this.rotateShow.top + "px";
      style.left = this.rotateShow.left + "px";
      return style;
    }
  },
  watch: {
    isShow (val) {
      // 第一次关闭
      this.showMatting = window.localStorage.getItem('showMatting');
      if (!val && !this.showMatting && this.hasMattingBtn) {
        window.localStorage.setItem('showMatting', true);
      }
    },
    SelectSprites_Msg(val, oldVal) {
      if (val.length > 0 && window._editor) console.log('素材id：', val.map(s => s.option.resourceId));
      if (val && val[0].type === 'Image' && val[0].opMatting && (val[0].opMatting.isMattingStatus === 2 || val[0].opMatting.isMattingStatus === 3)) {
        return;
      }
        this.initData();
    },
    "sprite.action": function(val, oldVal) {
      if (this.SelectSprites_Msg.length === 1 ) {
        let sp = this.SelectSprites_Msg[0];
        if (sp && sp.type === 'Image' && sp.opMatting && (sp.opMatting.isMattingStatus === 2 || sp.opMatting.isMattingStatus === 3)) {
        return;
        }
      }
      if (!this.sprite) {
        this.isShow = false;
        this.isShowRest = false;
        return;
      }
      if (!val) {
        this.initData();
      } else {
        this.isShow = false;
      }
    },
    "TOOL.multiSelect.action": function() {
      if (!this.TOOL.multiSelect.action) {
        this.initData();
      } else {
        this.isShow = false;
      }
    },
    fontSize(val, oldVal) {
      if (!this.change) return;
      this.changeFont("size-text");
    },
    strokeWidth(val, oldVal) {
      if (typeof val === "string") {
        val = val.trim();
      }
      if (val == null || (typeof val === "string" && val.trim() === "")) {
        this.strokeWidth = "";
        return;
      }
      // this.strokeWidth = val.trim();
      if ((val + "").length > 0 && typeof +val !== "number") {
        this.strokeWidth = oldVal;
      }
      if (this.strokeWidth !== this.strokeWidth) {
        this.strokeWidth = this.swRange.min;
      }
      if (this.strokeWidth < this.swRange.min) {
        this.strokeWidth = this.swRange.min;
      }
      if (this.strokeWidth > this.swRange.max) {
        this.strokeWidth = this.swRange.max;
      }
      if (!this.change) return;
      this.changeStrokeWidth();
    },
    "sprite.option.strokeWidth": {
      handler(val) {
        this.strokeWidth = val;
      }
    },
    TOOL: function(val) {
      if (val) {
        this.TOOL.on("updateSprite", this.setOpColorStyle);
      }
    },
    "TOOL.option.width"(val, oldVal) {
      this.initData();
    },
    "TOOL.option.height"(val, oldVal) {
      this.initData();
    },
    "TOOL.option.scale"(val, oldVal) {
      this.initData();
    },
    "ToolScroll_Size.top"(val, oldVal) {
      this.initData();
    },
    "ToolScroll_Size.left"(val, oldVal) {
      this.initData();
    },
    "sprite.effect.code": {
      handler(val) {
        this.isPathAnimDisabled = this.isSpecialEffect(val);
        this.$bus.emit("settingPopup.toggle", false);
      }
    }
  },
  created() {
    this.setOpColorStyle();
    this.$bus.on("settingPopup.toggle", flag => {
      if (!this.sprite) {
        return;
      }
      if (flag) {
        this.isShow = false;
        this.isShowRest = true;
        // this.initData({type: 'delete'});
      } else {
        this.isShowRest = false;
        this.initData();
      }
    });
    this.$bus.on("settingPopup.hideSpriteBtn", () => {
      this.isShow = false;
      this.isShowRest = false;
    });
  },
  beforeDestroy () {
    this.$bus.off('setting_matting', ()=>{
      this.isShow = false;
    });
  },
  mounted() {
    this.showMatting = window.localStorage.getItem('showMatting');
    this.$bus.on('setting_matting', ()=>{
      this.isShow = false;
    });
    this.$bus.on("updateEffect_vue", data => {
      if (data.type) {
        if (data.type === "path") {
          this.isShow = false;
        } else if (data.type === "noPath") {
          this.initData();
        }
      }
    });
    eve.on("sprite.update", () => {
      this.initData();
    });
    this.$bus.on("calcSpriteBtn", () => {
      // 实时移动设置按钮
      this.initData();
    });
    this.$bus.on("undoRedoHandle", data => {
      // 撤销和恢复的事件
      if (data.type === "matrix") this.initData();
    });
    this.$bus.on("panel_btn", data => {
      if (data.type === "fontSize") {
        this.fontSize = data.val;
      } else if (
        data.type === "fontColor" ||
        data.type === "fillColor" ||
        data.type === "strokeColor"
      ) {
        this.opColorStyle.backgroundColor = data.val;
      } else if (data.type === "strokeWidth") {
        this.strokeWidth = data.val;
      } else if (data.type === 'volume') {
        this.initData();
      }
    });
  },
  methods: {
    initData() {
      // 初始化数据，每个定位信息等
      if (
        this.SelectSprites_Msg &&
        this.SelectSprites_Msg.length === 1 &&
        !this.SelectSprites_Msg[0].effect.pathAnim.end &&
        !this.SelectSprites_Msg[0].locked
      ) {
        this.isShow = true;
        this.setOpColorStyle();
        this.sprite = this.SelectSprites_Msg[0];
        this.type = this.sprite.type;
        if (this.sprite.action) {
          this.isShow = false;
          return;
        }
        if (this.type === "Text") {
          this.fontSize = this.sprite.font.fontSize;
        }
        if (this.sprite.option.fileType === 29) {
          this.strokeWidth = this.sprite.option.strokeWidth;
        }
        this.calcPosition();
        this.button = this.getButton();
        this.rotateShow.top =
          this.sprite.positionTop +
          this.TOOL.fixTop -
          this.ToolScroll_Size.top +
          this.sprite.height / 2 -
          15;
        this.rotateShow.left =
          this.sprite.positionLeft +
          this.TOOL.fixLeft -
          this.ToolScroll_Size.left +
          this.sprite.width / 2 -
          15;
      } else if (this.SelectSprites_Msg && this.SelectSprites_Msg.length > 1) {
        this.sprite = {};
        this.isShow = true;
        this.type = "selectedSprites";
        this.button = this.getButton();
        this.calcPosition();
        let top = this.TOOL.multiSelect.css.top,
          left = this.TOOL.multiSelect.css.left;
        this.rotateShow.top = top + this.TOOL.fixTop - this.ToolScroll_Size.top;
        this.rotateShow.left =
          left + this.TOOL.fixLeft - this.ToolScroll_Size.left;
      } else {
        this.isShow = false;
        this.sprite = null;
      }
    },
    calcPosition() {
      // 计算帮助按钮的定位
      let points,
        calcPoints,
        w = this.Tool_Size.width,
        h = this.Tool_Size.height,
        calcLeft,
        calcTop;

      [points, calcPoints] = this.calcPoint();
      calcPoints.sort((a, b) => {
        return a.y - b.y;
      });

      calcLeft = points[0].x;
      calcTop = calcPoints[0].y - 50;

      if (calcLeft < 0) {
        this.position.left = 0;
      } else if (calcLeft > w - 170) {
        this.position.left = w - 170;
      } else {
        this.position.left = calcLeft;
      }

      if (calcTop < 0) {
        calcTop = calcPoints[3].y + 20;
        if (calcTop > h - 76) {
          calcTop = 0;
        }
        this.position.top = calcTop;
      } else if (calcTop > h - 76) {
        this.position.top = h - 76;
      } else {
        this.position.top = calcTop;
      }
    },
    calcPoint() {
      let info = {
          left: 0,
          top: 0,
          fixLeft: this.TOOL.fixLeft - this.ToolScroll_Size.left,
          fixTop: this.TOOL.fixTop - this.ToolScroll_Size.top,
          width: 0,
          height: 0
        },
        rotate = 0,
        points = [],
        calcPoints = [];
      if (this.SelectSprites_Msg && this.SelectSprites_Msg.length > 1) {
        info.left = this.TOOL.multiSelect.css.left;
        info.top = this.TOOL.multiSelect.css.top;
        info.width = this.TOOL.multiSelect.css.width;
        info.height = this.TOOL.multiSelect.css.height;
      } else {
        info.left = this.sprite.positionLeft;
        info.top = this.sprite.positionTop;
        info.width = this.sprite.width;
        info.height = this.sprite.height;
        rotate = this.sprite.rotate;
      }
      // 获取对应的4个点位置
      points[0] = {
        x: info.left + info.fixLeft,
        y: info.top + info.fixTop
      };
      points[1] = {
        x: info.left + info.fixLeft + info.width,
        y: info.top + info.fixTop
      };
      points[2] = {
        x: info.left + info.fixLeft + info.width,
        y: info.top + info.fixTop + info.height
      };
      points[3] = {
        x: info.left + info.fixLeft,
        y: info.top + info.fixTop + info.height
      };
      points[4] = {
        x: info.left + info.fixLeft + info.width / 2,
        y: info.top + info.fixTop + info.height / 2
      };

      calcPoints[0] = this.rotate(points[0], rotate, points[4]);
      calcPoints[1] = this.rotate(points[1], rotate, points[4]);
      calcPoints[2] = this.rotate(points[2], rotate, points[4]);
      calcPoints[3] = this.rotate(points[3], rotate, points[4]);

      return [points, calcPoints];
    },
    rotate(action, data, o) {
      // Angle为正时逆时针转动, 单位为弧度
      data = (Math.PI / 180) * data;
      var b = {};
      b.x =
        (action.x - o.x) * Math.cos(data) -
        (action.y - o.y) * Math.sin(data) +
        o.x;
      b.y =
        (action.x - o.x) * Math.sin(data) +
        (action.y - o.y) * Math.cos(data) +
        o.y;

      return b;
    },
    delSprite() {
      this.TOOL.removeSprite(this.sprite.id, true);
      window.dispatchEvent(new MouseEvent("mousedown"));
      this.$root.$el.dispatchEvent(new MouseEvent("mousedown"));
    },
    async actionHandle(e, action) {
      // 帮助按钮的点击事件
      if (!this.sprite) return;
      if (action === "next") {
        return;
      }
      switch (action) {
        case 'censoredInfo':
          {
            // const resp = await this.$http.get('/api/forbidden/info', {
            //   params: {
            //     url: this.$handleAssetsUrl(this.sprite.option.url)
            //   }
            // });
            // console.log(`Turbo ~ actionHandle ~ resp.data`, resp.data)
            const found = this.button.find(v => v.action === 'censoredInfo');
            found && this.$modal.show('censoredInfo', {data: found.censoredInfo});
          }
          break;
        case "matting": {
          if(!this.judgeMatting()) {
            // 抠图剩余次数为0
            return;
          }
          let url = this.sprite.option.url;
          let tSprite = {};
          tSprite = Object.assign(tSprite, this.sprite);
          tSprite.mattingPicture = this.sprite.mattingPicture;
          tSprite.finishApiMatting = this.sprite.finishApiMatting;
          this.isShow = false;
          tSprite.mattingPicture();
          let res = await this.$http.post(`/api/common/cutout?key=${url}`); // &type=2&faceAnalysis=1
          if (!res.data || res.data.code !== 200) {
            return;
          }
          let result = res.data.data;
          tSprite.finishApiMatting({
            data: result.url
          });
          sensors.track('doratoonMatting', {
          });
          const {num, use} = result;
          this.$store.commit('toggle_UserMsgCutout', {num, use});
          break;
        }
        case "delete":
          if (this.SelectSprites_Msg && this.SelectSprites_Msg.length > 1) {
            let data = {
              id: this.SelectScenes_Msg.id,
              sprites: [],
              scale: this.TOOL.scale
            };
            this.TOOL.selectedSprite.reduce((sequence, sprite) => {
              return sequence.then(() => {
                data.sprites.push(sprite.toJson(true));
                return this.TOOL.removeSprite(sprite.id);
              });
            }, Promise.resolve());

            this.TOOL.selectSprite();
            eve("undo_redo", null, { type: "ctrlDelete", data: data });
            action = action + "All";
          } else {
            this.TOOL.removeSprite(this.sprite.id, true);
          }
          break;
        case "swap": {
          const runner = () => {
            let longType = this.getNavType();
            let typeArr = longType.split(".");
            // 打开 rightNav
            this.$bus.emit("materialPane_vue", {
              type: typeArr[0],
              name: typeArr[1],
              judge: !!typeArr[1]
            });
            // this.$bus.emit("materialPane_vue", { type: "personal"});
            this.$bus.emit("personal_tab_FS_vue", {
              type: 'collectionCategory'
            })
            this.$store.commit("save_SpriteOperation", "swap");
            // 弹出气泡提示
            this.$bus.emit("blackPopupMsg_showTips", {
              text: "选择左边的素材可进行替换",
              position: {
                top: "186px",
                left: this.MaterialPane_Size.width + 20 + "px"
              }
            });
          };
          // this.isShow = false;
          if (this.MaterialNavReady) {
            runner();
          } else {
            // this.$bus.emit("materialPane_vue", { type: "props" });
            setTimeout(runner, 500);
          }
          break;
        }
        case "tailor": {
          if (this.sprite.cropType !== "svg") {
            this.$bus.emit("cropfreelayer");
          } else {
            this.$bus.emit("cropsvglayer");
          }
          this.$bus.emit("FeaturesPop_vue", {
            name: "cropping",
            type: 1,
            sprite: this.sprite
          });
          break;
        }
        case "flip":
          this.sprite.flipStyle(true);
          break;
        case "size-minus":
          if (this.sprite.font.fontSize <= 6) return;
          this.TOOL.updateSprite(
            this.sprite.id,
            {
              font: {
                fontSize: --this.fontSize
              }
            },
            this.sprite.scenesId,
            true
          );
          this.$bus.emit("btn_panel", {
            type: "fontSize",
            data: this.fontSize
          });
          break;
        case "size-plus":
          if (this.sprite.font.fontSize >= 1080) return;
          this.TOOL.updateSprite(
            this.sprite.id,
            {
              font: {
                fontSize: ++this.fontSize
              }
            },
            this.sprite.scenesId,
            true
          );
          this.$bus.emit("btn_panel", {
            type: "fontSize",
            data: this.fontSize
          });
          break;
        case "stroke-width":
          break;
        case "stroke-width-minus":
          if (this.sprite.option.strokeWidth == null) {
            this.TOOL.updateSprite(
              this.sprite.id,
              {
                strokeWidth: 5
              },
              this.sprite.scenesId,
              true
            );
            return;
          }
          if (this.sprite.option.strokeWidth <= this.swRange.min) return;
          this.TOOL.updateSprite(
            this.sprite.id,
            {
              strokeWidth: --this.strokeWidth
            },
            this.sprite.scenesId,
            true
          );
          this.$bus.emit("btn_panel", {
            type: "strokeWidth",
            data: this.strokeWidth
          });
          break;
        case "stroke-width-plus":
          if (this.sprite.option.strokeWidth == null) {
            this.TOOL.updateSprite(
              this.sprite.id,
              {
                strokeWidth: 5
              },
              this.sprite.scenesId,
              true
            );
            return;
          }
          if (this.sprite.option.strokeWidth >= this.swRange.max) return;
          this.TOOL.updateSprite(
            this.sprite.id,
            {
              strokeWidth: ++this.strokeWidth
            },
            this.sprite.scenesId,
            true
          );
          this.$bus.emit("btn_panel", {
            type: "strokeWidth",
            data: this.strokeWidth
          });
          break;
        case "path-anim":
          this.setPathAnim();
          break;
        case "cut":
          if (!this.sprite.picData.picSize) return;
          this.$bus.emit("cutFrame_vue");
          this.sprite.action = "cut";
          break;
        case "set-muted":
          this.sprite.toggleMuted(true);
          this.$bus.emit("btn_panel", {
            type: "volume",
            data: 0
          });
          this.$bus.emit("calcSpriteBtn");
          break;
        case "cancel-muted":
          this.sprite.toggleMuted(false);
          this.$bus.emit("calcSpriteBtn");
          this.$bus.emit("btn_panel", {
            type: "volume",
            data: 50
          });
          break;
        case "cut-video":
          this.$modal.show("videoSprite.cutting", {
            sprite: this.SelectSprites_Msg[0]
          });
          break;
        case "layerSetting":
          this.$bus.emit("FeaturesPop_vue", {
            name: "sprites",
            posx: this.position.left + this.ToolScroll_Size.left - 100,
            posy: this.position.top + this.ToolScroll_Size.top + 100,
            type: 2,
            actionType: "layerSetting"
          });
          break;
        case "spritesAlign":
          this.$bus.emit("FeaturesPop_vue", {
            name: "sprites",
            posx: this.position.left + this.ToolScroll_Size.left - 100,
            posy: this.position.top + this.ToolScroll_Size.top + 100,
            type: 2,
            actionType: "spritesAlign"
          });
          break;
        case "animationSetting":
          this.$bus.emit("FeaturesPop_vue", {
            name: "selectSpritesEffect",
            posx: this.position.left + this.ToolScroll_Size.left - 100,
            posy: this.position.top + this.ToolScroll_Size.top + 100,
            type: 1
          });
          break;
        case "lock":
          this.sprite.setLocked(true);
          this.sprite.showHideHandle(true);
          this.initData();
          break;
        case "drawingDuration":
          this.$bus.emit("FeaturesPop_vue", {
            name: "drawingDuration",
            type: 1,
            sprite: this.sprite
          });
          break;
        case "effect":
          this.$bus.emit("FeaturesPop_vue", {
            name: "effectSetting",
            type: 1,
            // isChild: true,
            source: this,
            sprite: this.sprite
          });
          break;
        case "favorite":
          (async () => {
            let s = this.SelectSprites_Msg[0];
            let postBody = {
              title: ''
            };
            if(s && s.option.resourceId !== this.favoriteId && this.favoriteStatus === 0) {
              ({
                resourceId: postBody.id,
                fileType: postBody.fileType,
                url: postBody.url,
              } = s.option)
              this.favoriteId = postBody.id;
              this.favoriteStatus = 1;
              let urlArr = postBody.url.split('.');
              let fileType = urlArr.pop();
              let fileName = urlArr.join("");
              let fileTypeLower = fileType.toLowerCase();
              if(!postBody.fileType && fileTypeLower === 'json') {
                postBody.fileType = 5;
              }
              if(!postBody.fileType) {
                this.$message({
                  showClose: true,
                  message: "该类素材不支持收藏",
                  type: "error"
                });
                this.favoriteId = "";
                this.favoriteStatus = 0;
                return;
              }
              this.$message({
                showClose: true,
                message: "正在收藏中...",
              });
              if(fileTypeLower === 'json') {
                fileName = `${fileName}nail.png`;
                if(await this.loadImg(fileName)) {
                  postBody.thumbnailUrl = fileName;
                } else {
                  // 截图上传 (后端处理)
                  let svg = s.ele.children("svg")[0];
                  let width = + svg.getAttribute("width");
                  let height = + svg.getAttribute("height");
                  let blob = new Blob([svg.outerHTML], {type: 'image/svg+xml;charset=utf-8'});
                  let blobUrl = URL.createObjectURL(blob);
                  let img = await this.loadImg(blobUrl, true);
                  if(img) {
                    let canvas = document.createElement('canvas');
                    canvas.width = width;
                    canvas.height = height;
                    let ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, width, height);
                    blob = await new Promise(resolve => {
                      canvas.toBlob(resolve)
                    })
                    let formData = new FormData();
                    formData.append("lottieThumb", blob);
                    let res = await this.$http({
                      url: "/api/upload/file",
                      method: "post",
                      data: formData,
                      dataType: "json",
                      Headers: {
                        "Content-Type": "multipart/form-data; boundary=---12321"
                      }
                    }).catch(() => {
                      return null
                    })
                    if(res && res.data && res.data.data) {
                      postBody.thumbnailUrl = res.data.data.filename || '';
                    }
                  }
                }
              } else if(fileTypeLower === 'svg') {
                fileName = `${fileName}.png`;
                if(await this.loadImg(fileName)) {
                  postBody.thumbnailUrl = fileName;
                } else {
                  postBody.thumbnailUrl = postBody.url;
                }
              } else {
                fileName = `${fileName}nail.${fileType}`;
                if(await this.loadImg(fileName)) {
                  postBody.thumbnailUrl = fileName;
                } else {
                  postBody.thumbnailUrl = postBody.url;
                }
              }
              this.$http.post("/api/user/favorites", postBody).then(res => {
                this.favoriteStatus = 0;
                this.favoriteId = "";
                if(res.status === 200) {
                  if(res.data.code === 200) {
                    let fType = '';
                    if(res.data.data) {
                      if(res.data.data.returnId && !postBody.id) {
                        s.option.resourceId = res.data.data.returnId;
                      }
                      if(res.data.data.newTable) {
                        switch(res.data.data.newTable) {
                          case "PROP":
                            fType = "props";
                            break;
                          case "CHARACTERS":
                            fType = "characters";
                            break;
                          case "MUSIC":
                            fType = "music";
                            break;
                          case "SHAPE":
                            fType = "shapes";
                            break;
                          case "TEXT":
                            fType = "text";
                            break;
                          case "GIF":
                            fType = "gif";
                            break;
                          case "BG":
                            fType = "bg";
                            break;
                        }
                      }
                    }
                    this.$message({
                      showClose: true,
                      message: '收藏成功',
                    });
                    // 最新的收藏事件
                    this.$bus.emit('open-resource-area', this.fileTypeToType(+postBody.fileType))
                  } else {
                    this.$message({
                      showClose: true,
                      message: res.data.msg,
                      type: "error"
                    });
                  }
                } else {
                  this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: "error"
                  });
                }
              })
            } else {
              this.$message({
                showClose: true,
                message: "收藏太频繁，请稍等重试",
              });
            }
          })()
          break;
        default:
          let data = {};
          data.type = 1;
          data.sprite = this.sprite;
          // data.name = action + '_' + this.sprite.type;
          data.name = "spritePopup";
          data.posx = e.pageX;
          data.posy = e.pageY;
          if (
            action === "color" &&
            this.$isEditableShape(this.sprite.option.fileType)
          ) {
            data.name = action + "_" + this.sprite.type;
            data.whichPart = "fill";
            data.color = this.sprite.option.fill;
          }
          if (
            action === "color" &&
            this.$isEditableLine(this.sprite.option.fileType)
          ) {
            data.name = action + "_" + this.sprite.type;
            data.whichPart = "stroke";
            data.color = this.sprite.option.stroke;
          }
          if (action === "color") {
            data.name = action + "_" + this.sprite.type;
          }
          // motion 角色动作
          // edit 图表编辑
          // switch 图表类型转换
          if (action === "motion" || action === "edit" || action === "switch") {
            const type = this.sprite.type === 'Gif' ? 'Lottie' : this.sprite.type;
            data.name = action + "_" + type;
          }

          this.$bus.emit("FeaturesPop_vue", data);
      }
      if (this.ANALYSIS[action] && this.ANALYSIS[action].category) {
        this.$analysis(this.ANALYSIS[action]);
      }
    },
    sizeHoldDown(e, action) {
      this.holdStartTime = new Date().getTime(); //记录按下的时间
      this.holdTimer = setInterval(() => {
        //触发定时器100毫秒检测一次
        this.holdEndTime = new Date().getTime();
        if (this.holdEndTime - this.holdStartTime > 500) {
          //当按下500毫秒时，判断为长按钮
          clearInterval(this.holdTimer); //停止检测长按的定时器
          this.sizeTimer = setInterval(() => {
            //通过定时器实现字体大小连续递增递减
            this.actionHandle(e, action);
          }, 100);
        }
      }, 100);
    },
    sizeHoldUp() {
      clearInterval(this.holdTimer);
      clearInterval(this.sizeTimer);
      this.holdStartTime = 0;
      this.holdEndTime = 0;
    },
    focusF() {
      // 输入框的focus事件
      this.$store.commit("toggle_isPreventDefault", false);
      this.change = true;
    },
    blurF() {
      this.$store.commit("toggle_isPreventDefault", true);
      this.change = false;
    },
    changeFont(action) {
      // 改变字体大小
      if (action === "size-text") {
        if (+this.fontSize) {
          if (this.fontSize >= 6 && this.fontSize <= 1080) {
            this.TOOL.updateSprite(
              this.sprite.id,
              {
                font: {
                  fontSize: +this.fontSize
                },
                artStyle: this.getStyle(
                  this.sprite.artType,
                  this.sprite.font.color,
                  +this.fontSize
                )
              },
              this.sprite.scenesId,
              true
            );
            this.$bus.emit("btn_panel", {
              type: "fontSize",
              data: +this.fontSize
            });
          }
        } else {
          return;
        }
      }
    },
    changeStrokeWidth() {
      if (
        this.strokeWidth >= this.swRange.min &&
        this.strokeWidth <= this.swRange.max
      ) {
        this.TOOL.updateSprite(
          this.sprite.id,
          {
            strokeWidth: this.strokeWidth
          },
          this.sprite.scenesId,
          true
        );
      }
    },
    getButton() {
      // 按钮的信息
      let button = [];
      let reg = /.svg$/g;
      if (this.type === 'Image' && this.sprite && reg.test(this.sprite.option.url)) {
        this.type = 'Svg';
      }
      // console.log('this.type', this.type);
      switch (this.type) {
        case "Text":
          button = [].concat([
            // 按钮的信息，包括提示
            { action: "next", helpText: "文字尺寸" },
            { action: "color", helpText: "颜色" },
            { action: "path-anim", helpText: "路径动画" },
            { action: "delete", helpText: "删除" },
            { action: "lock", helpText: "锁定" },
          ]);
          break;
        case "RichText":
          button = [].concat([
            // 按钮的信息，包括提示
            { action: "path-anim", helpText: "路径动画" },
            { action: "delete", helpText: "删除" },
            { action: "lock", helpText: "锁定" },
          ]);
          break;
        case "Image":
          button = [].concat([
            // 按钮的信息，包括提示
            { action: "flip", helpText: "翻转" },
            { action: "path-anim", helpText: "路径动画" },
            { action: "delete", helpText: "删除" },
            { action: "lock", helpText: "锁定" },
            {action: "tailor", helpText: "剪裁"},
            {action: "matting", helpText: "抠图"},
            { action: "swap", helpText: "替换" },
            { action: "favorite", helpText: "收藏" }
          ]);
          this.$http.get('/api/forbidden/info', {
            params: {
              url: this.$handleAssetsUrl(this.sprite.option.url)
            }
          })
          .then(resp => {
            const data = (resp.data || {}).data;
            if (data && data.censorType) {
              this.button = [{action: 'censoredInfo', helpText: '查看详情', censoredInfo: data}];
            }
          });
          break;
        case "Lottie":
          button = [
            // 按钮的信息，包括提示
            { action: "flip", helpText: "翻转" },
            { action: "path-anim", helpText: "路径动画" },
            { action: "delete", helpText: "删除" },
            { action: "lock", helpText: "锁定" },
            { action: "swap", helpText: "替换" },
            { action: "favorite", helpText: "收藏" }
          ];
          if (this.getNavType() === "characters") {
            // button.splice(1, 0, { action: "motion", helpText: "动作" })
            button.unshift({ action: "motion", helpText: "动作" });
          }
          break;
        case "Svg":
          // 按钮的信息，包括提示
          button = [].concat([
            // { action: "flip", helpText: "翻转" },
            { action: "path-anim", helpText: "路径动画" },
            { action: "delete", helpText: "删除" },
            { action: "lock", helpText: "锁定" },
            { action: "swap", helpText: "替换" },
            { action: "favorite", helpText: "收藏" }
          ]);
          if (this.$isEditableLine(this.sprite.option.fileType)) {
            button.unshift(
              { action: "stroke-width", helpText: "线条" },
              { action: "color", helpText: "颜色" }
            );
          }
          if (this.$isEditableShape(this.sprite.option.fileType)) {
            button.unshift({ action: "color", helpText: "颜色" });
          }
          if (this.sprite.effect.code === "Hand") {
            button = [
              ...button.slice(0, -2),
              { action: "drawingDuration", helpText: "手绘时间" },
              ...button.slice(-2)
            ];
          }

          break;
        case "Frame":
          button = [].concat([
            // 按钮的信息，包括提示
            { action: "flip", helpText: "翻转" },
            { action: "path-anim", helpText: "路径动画" },
            { action: "delete", helpText: "删除" },
            { action: "lock", helpText: "锁定" },
            { action: "swap", helpText: "替换" },
            { action: "favorite", helpText: "收藏" }
          ]);
          break;
        case "Chart":
          button = [
            // 按钮的信息，包括提示
            { action: "edit", helpText: "编辑数据" },
            { action: "switch", helpText: "切换图表" },
            { action: "path-anim", helpText: "路径动画" },
            { action: "delete", helpText: "删除" },
            { action: "lock", helpText: "锁定" }
          ];
          break;
        case "Gif":
          button = [
            { action: "flip", helpText: "翻转" },
            { action: "path-anim", helpText: "路径动画" },
            { action: "delete", helpText: "删除" },
            { action: "lock", helpText: "锁定" },
            { action: "swap", helpText: "替换" },
            { action: "favorite", helpText: "收藏" }
          ];
          // 数字人 57 100
          // gif角色 118
          if ([57, 100, 118].includes(this.sprite.option.fileType)) {
            button.unshift({ action: "motion", helpText: "动作" });
          }
          break;
        case "Video":
          button = [
            { action: "cut-video", helpText: "裁剪时长" },
            { action: "set-muted", helpText: "设为静音" },
            { action: "path-anim", helpText: "路径动画" },
            { action: "delete", helpText: "删除" },
            { action: "lock", helpText: "锁定" },
            { action: "swap", helpText: "替换" }
          ];
          if (this.sprite.video.volume === 0) {
            button[1] = { action: "cancel-muted", helpText: "取消静音" };
          }
          if (this.sprite.video && !this.sprite.video.hasAudio) {
            button.splice(1, 1);
          }
          this.$http.get('/api/forbidden/info', {
            params: {
              url: this.$unhandleAssetsUrl(this.sprite.option.url)
            }
          })
          .then(resp => {
            const data = (resp.data || {}).data;
            if (data && data.censorType) {
              this.button = [{action: 'censoredInfo', helpText: '查看详情', censoredInfo: data}];
            }
          });
          break;
        case "selectedSprites":
          button = [
            { action: "delete", helpText: "删除" },
            { action: "layerSetting", helpText: "图层" }
          ];
          break;
      }
      return button;
    },
    getIconClass(action) {
      let temp = action;
      if (temp === "cancel-muted") {
        action = "set-muted";
      }
      if (temp === "set-muted") {
        action = "cancel-muted";
      }
      if (temp === "drawingDuration") {
        action = "drawing-duration";
      }
      return action;
    },
    setOpColorStyle() {
      let sprite = this.SelectSprites_Msg[0] || {};
      let color;
      if (sprite.type === "Svg") {
        color =
          sprite.option.fileType === 29
            ? sprite.option.stroke
            : sprite.option.fill;
      }
      if (sprite.type === "Shape" && sprite.option.style) {
        color = sprite.option.style.color;
      }
      if (sprite.type === "Text") {
        color = sprite.font.color;
      }
      this.$set(this.opColorStyle, "backgroundColor", color || "#5778fb");
    },
    onME(ev) {
      let el = ev.currentTarget;
      let iEl = el.querySelector("i.icon");
      iEl && iEl.classList.toggle("active");
    },
    onML(ev) {
      this.onME(ev);
    },
    setPathAnim() {
      let hasPathAnim = false;
      if (this.isSpecialEffect(this.sprite.effect.code)) {
        return;
      }
      // 弹出气泡提示
      // this.$bus.emit('showTips', {
      //   text: '试试拖动其中一个素材，可调整素材运动的路线；点击“小剪刀”可取消路径动画；调整时间轴上的路径动画，可调整运动的时间。',
      //   position: {
      //     top: `${this.TopNav_Size.height + 10}px`,
      //     right: `${this.RightNav_Size.width + 20}px`
      //   }
      // })
      if (this.TOOL.selectedSprite && this.TOOL.selectedSprite.length) {
        let a = this.TOOL.selectedSprite[0];
        if (a.effect.pathAnim.target) {
          hasPathAnim = true;
        }
        let start = this.TOOL.selectedSprite[0].effect.entranceAnim.end,
          end = start + 2000;
        end > this.TOOL.selectedSprite[0].effect.exitAnim.start &&
          (end = this.TOOL.selectedSprite[0].effect.exitAnim.start);
        if (end <= start) {
          end = start + 500;
        }
        let {
          positionTop: y,
          positionLeft: x,
          width: w,
          height: h,
          rotate
        } = a;
        a.updateEffect(
          {
            pathAnim: hasPathAnim
              ? a.effect.pathAnim
              : {
                  start: start,
                  end: end,
                  scale: this.TOOL.scale,
                  target: {
                    x: x + 100,
                    y: y + 100,
                    rotate,
                    w: w,
                    h: h
                  }
                },
            stayAnim: {
              type: "None"
            }
          },
          hasPathAnim ? false : true
        );
        // a.effect.init();
        this.$bus.emit("updateEffect_vue", {
          sprite: this.SelectSprites_Msg[0],
          effect: this.sprite.effect || {},
          type: "path"
        });

        this.$bus.emit("settingPopup.hideSpriteBtn");

        this.$bus.emit("FeaturesPop_close_vue", { type: 3 });

        // this.$bus.emit('FeaturesPop_vue',{
        //   name: 'pathEffectSetting',
        //   sprite: this.SelectSprites_Msg[0],
        //   type: 1
        // });
      }
    },
    isDrawEffect(code) {
      return /^(?:draw|hand|write)$/i.test("" + code);
    },
    isAppearEffect(code) {
      return /^(?:appear|type|bounce|roll)$/i.test("" + code);
    },
    isSpecialEffect(code) {
      return this.isDrawEffect(code) || this.isAppearEffect(code);
    },
    async loadImg(url, blob) {
      let imgPro = new Promise((resolve) => {
        let img = new Image();
        img.onload = () => {
          resolve(img);
        };
        img.onerror = () => {
          resolve(false);
        };
        setTimeout(() => {
          resolve(false);
        }, 800)
        if(blob) {
          img.src = url
        } else {
          img.src = this.$handleAssetsUrl(url);
        }
      });

      return await imgPro;
    },
    fileTypeToType(fileType) {
      let type = '';
      let index = -1;
      //	3：背景 14: 人物，15: 形状，16：文字，17：道具 36:gif
      // 没有对应 4: 图片 5：音乐 8：模板
      // 视频没有对应（ 收藏没有视频 1：视频，）
      switch(fileType) {
        case 1:
        case 2:
        case 25:
          type = 'bg' // 3 背景
          index = 2
          break;
        case 3:
        case 4:
        case 5:
        case 22:
        case 35:
        case 42:
        case 46:
        // 图片都归为道具
        case 18:
        case 19:
        case 34:
        case 47:
          type = 'props' // 17 道具
          index = 5
          break;
        case 10:
        case 118:
          type = 'characters' // 14
          index = 4
          break;
        case 6:
        case 7:
        case 8:
        case 9:
        case 23:
        case 28:
        case 29:
        case 33:
        case 30:
          type = 'shapes' // 15 形状
          index = 5
          break;
        case 11:
        case 12:
        case 13:
          type = 'text' // 16 文字
          index = 3
          break;
        case 32:
          type = 'gif' // 37 gif
          index = 5
          break;
      }
      return {type, index}
    }
  }
};
</script>

<style lang="scss" scoped>
.matting-tips {
  position: absolute;
  z-index: 140;
  .text {
    position: absolute;
    top: -98px;
    left: 258px;
    z-index: 1;
    width: 184px;
    height: 56px;
    padding: 10px 0;
    background-color: #5778FB;
    border-radius: 4px;
    p {
      color: #fff;
      font-size: 12px;
      line-height: 20px;
    }
  }
  .arrow {
    position: absolute;
    left: 232px;
    top: -54px;
    z-index: 1;
    width: 58px;
    height: 68px;
    background-image: url('../../../static/svg/matting-arrow.svg');

  }
}
.handle-button {
  position: absolute;
  display: flex;
  z-index: 125;
  border: 2px solid rgb(255, 255, 255);
  border-radius: 6px;
  overflow: hidden;
  background: rgb(255, 255, 255);
}
.op-handle-button {
  > div {
    width: 102px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  background-image: none;
}
.op-handle-color {
  > div {
    width: 26px;
    height: 22px;
    border-radius: 4px;
  }
}
.rotate-show {
  position: absolute;
  top: 0;
  left: 0;
  width: 30px;
  height: 30px;
  line-height: 28px;
  color: #fff;
  font-size: 11px;
  border: 1px solid #fff;
  border-radius: 50%;
  z-index: 125;
  user-select: none;
  background: rgba(0, 0, 0, 0.5);
}

.op-handle-path-anim.disabled {
  display: none;
  cursor: not-allowed;
}
.op-handle-matting {
  width: 40px;
}
.op-handle-tailor,.op-handle-swap, .op-handle-favorite {
  width: 40px;
  margin-right: 0;
}
.op-handle-swap, .op-handle-favorite {
  > span {
    margin-left: 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/tool/spriteBtn.vue